import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLayoutContext } from "../../layouts/general-layout";
import { RouterConstant } from "../../routers/index";
import { useUserStore } from '../../utils/userStore';
import { PointIcon } from '../../assets/images';
import { LoginService } from "../../services/login/login.services";
import PasswordInput from "../../components/password-input";

import "./reset-password.scss";
import LoginHeader from '../../components/login-header';
import Button from '../../components/button';

const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;

export default function Index() {
    const { t } = useLayoutContext();
    const navigate = useNavigate();
    const loginService = new LoginService();
    const { ROUTERS_PATH } = RouterConstant;
    const { setUserInfo } = useUserStore();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState<{ password?: string; confirmPassword?: string; api?: string }>({});
    const [loading, setLoading] = useState(false);
    const { userInfo, resetUser } = useUserStore();
    const email = userInfo?.email || '';

    const handleBackClick = () => {
        navigate(ROUTERS_PATH.LOGIN);
    };

    const validate = () => {
        const newErrors: typeof errors = {};
        if (!passwordRegex.test(password)) {
            newErrors.password = t("passwordInvalid");
        }
        if (confirmPassword !== password) {
            newErrors.confirmPassword = t("passwordsDoNotMatch");
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        setLoading(true);
        setErrors({});
        try {
            await loginService.updatePassword(password);
            resetUser();
            navigate(ROUTERS_PATH.LOGIN);
        } catch (err: any) {
            const code = err.response?.data?.detail?.error_code ?? 99;
            let message = t("unexpectedError");
            if (code === 3) {
                message = t("emailDoesNotExist");
            }
            setErrors({ api: message });
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="reset-password-page">
            <LoginHeader handleBackClick={handleBackClick} title={t("passwordReset")} subtitle={t("enterNewPassword")} noImg={true} />
            <div className='reset-password-form'>
                <div className="reset-password-form-wrapper">
                    <div className="reset-password-form-fields">
                        <PasswordInput
                            placeholder={`*${t("password")}`}
                            value={password}
                            onChange={setPassword}
                            error={errors.password}
                            infoText={t("passwordInputInfo")}
                            icon={PointIcon}
                        />
                        <PasswordInput
                            placeholder={`*${t("repeatPassword")}`}
                            value={confirmPassword}
                            onChange={setConfirmPassword}
                            error={errors.confirmPassword}
                            infoText={t("passwordInputInfo")}
                            icon={PointIcon}
                        />
                        {errors.api && <p className="error-text">{errors.api}</p>}
                    </div>
                </div>

                <div className="password-reset-form-action">
                    <Button
                        type="submit"
                        text={t("saveNewPassword")}
                        color="blue"
                        onClick={handleSubmit}
                        loader={loading}
                        disabled={loading}
                    />
                </div>
            </div>
        </div>
    );
}